<template>
  <div id="app">

    <!--    <transition-->
    <!--      name="fade"-->
    <!--    >-->
    <router-view/>
    <!--    </transition>-->

  </div>
</template>
<script>

  import store from "./store/store";
  import 'element-closest-polyfill';
  export default {

    data() {
      return {
        store: store,
        auth: false,
        transitionName: '',
      }
    },
    methods: {
    },
    computed: {},
    created() {
    },
    components: {},
    name: 'App'
  }
</script>

<style lang="scss">

  @keyframes slide-in-right {
    from {
      right: -200%;
    }
    to {
      background-color: red;
      right: 0;
    }
  }

  @keyframes slide-out-right {
    from {
      right: 0;
    }
    to {
      background-color: red;
      right: -200%;
    }
  }


  @import "styles/style";

  .lightmode {
    @import "styles/light";
  }


  /*.fade-enter-active,*/
  /*.fade-enter-active,*/
  /*.fade-leave-active main,*/
  /*.fade-leave-active main {*/
  /*  !*transition-duration: 0.3s;*!*/
  /*  !*transition-property: opacity;*!*/
  /*  !*transition-timing-function: ease;*!*/
  /*}*/

  /*.fade-enter main,*/
  /*.fade-leave-active main {*/
  /*  opacity: 0*/
  /*}*/


</style>



// WEBPACK FOOTER //
// src/App.vue